// @ts-nocheck
import objectKeys from "@store/Framework/Common/Utilities/objectKeys";
import { PackagingAdviceFormFieldValues } from "@store/Framework/Store/Greif/Components/PackagingAdviceForm/PackagingAdviceFormState";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";
import isEqual from "lodash/isEqual";

type HandlerType = Handler<Partial<PackagingAdviceFormFieldValues>>;

export const DispatchSetDraftFieldValuesIfNeeded: HandlerType = props => {
    const { formDraftFieldValues } = props.getState().greif.components.packagingAdviceForm;

    if (!objectKeys(props.parameter)?.some(x => !isEqual(props.parameter[x], formDraftFieldValues[x]))) {
        return;
    }

    props.dispatch({
        type: "Greif/Components/PackagingAdviceForm/SetDraftFieldValues",
        parameter: props.parameter,
    });
};

export const chain = [DispatchSetDraftFieldValuesIfNeeded];

const setDraftFieldValues = createHandlerChainRunner(chain, "SetDraftFieldValues");

export default setDraftFieldValues;
